import { appRoutes } from "~/constants/appRoutes.ts";

export const INTENDED_LOCATION_KEY = "intendedLocation";

export const deleteIntendedLocation = () => {
	localStorage.removeItem(INTENDED_LOCATION_KEY);
};

export const getIntendedLocation = (): string | null => {
	const location = localStorage.getItem(INTENDED_LOCATION_KEY);
	if (location) {
		return JSON.parse(location);
	}
	return null;
};

// The public pages are never a target: a stored login or reset link would send the user back to it after the login.
const isPublicPath = (path: string) => [
	appRoutes.base().path,
	appRoutes.login().path,
	appRoutes.passwordResetRequest().path,
].includes(path) || path.startsWith(appRoutes.passwordReset().path.replace(":token", ""));

export const setIntendedLocation = (intendedLocation: string | null = null) => {
	intendedLocation = intendedLocation || window.location.pathname;

	if (!isPublicPath(intendedLocation)) {
		localStorage.setItem(INTENDED_LOCATION_KEY, JSON.stringify(intendedLocation));
	}
};
